export default class InputType {

  static constructFromObject(data) {
    return data? String(data) : "undefined";
  }
}
